import React, { useState } from "react"; // Added useEffect if needed for data fetching
import TestingTerminal from "./TestingTerminal";
import ProductionTerminal from "./ProductionTerminal";
import { useLocation, useParams } from "react-router-dom";

// 1. Accept props (deviceId) passed from Devices.js
const RemoteSSH = ({ deviceId: propDeviceId }) => { 
  const [isProduction, setIsProduction] = useState(true);
  const location = useLocation();
  const { id: paramId } = useParams();

  // 2. Safe Destructuring: Handle case where location.state is null
  // If state is null, default to an empty object so destructuring doesn't crash
  const { data } = location.state || {}; 

  // 3. Determine the actual ID being used (Prop vs URL Param vs State)
  const activeDeviceId = propDeviceId || paramId || data?.deviceId;
  const activeId=String(activeDeviceId)

  const handleToggle = () => {
    setIsProduction(!isProduction);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        backgroundColor: "#1e1e1e",
        overflow: "hidden",
      }}
    >
      
      
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#252526",
          borderBottom: "1px solid #3e3e42",
          padding: "8px 16px",
          height: "50px",
          flexShrink: 0,
        }}
      >
         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span
            style={{
              fontSize: "14px",
              color: "#cccccc",
              fontWeight: "500",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            {isProduction ? "Production Terminal" : "Testing Terminal"}
          </span>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#4ec9b0",
              boxShadow: "0 0 4px rgba(78, 201, 176, 0.6)",
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span
            style={{
              fontSize: "12px",
              color: "#858585",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            Testing
          </span>

          <div
            onClick={handleToggle}
            style={{
              width: "48px",
              height: "24px",
              backgroundColor: isProduction ? "#4ec9b0" : "#555",
              borderRadius: "12px",
              cursor: "pointer",
              position: "relative",
              transition: "background-color 0.3s ease",
            }}
          >
            <div
              style={{
                width: "18px",
                height: "18px",
                backgroundColor: "#ffffff",
                borderRadius: "50%",
                position: "absolute",
                top: "3px",
                left: isProduction ? "27px" : "3px",
                transition: "left 0.3s ease",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>

          <span
            style={{
              fontSize: "12px",
              color: isProduction ? "#4ec9b0" : "#858585",
              fontFamily: "system-ui, -apple-system, sans-serif",
              fontWeight: isProduction ? "600" : "normal",
            }}
          >
            Production
          </span>
        </div>
      </div>

      <div style={{ flex: 1, overflow: "hidden" }}>
        {isProduction ? <ProductionTerminal deviceId={activeId} /> : <TestingTerminal />}
      </div>
    </div>
  );
};

export default RemoteSSH;